import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgDarkSpotFormulaGlyphSecondary from './svgs/DarkSpotFormulaGlyphSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var darkSpotFormulaGlyph = (props => useIcon(null, SvgDarkSpotFormulaGlyphSecondary, props));

export { darkSpotFormulaGlyph as default };
